/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/no-noninteractive-tabindex */

import React, { useCallback, useContext } from 'react';

import classNames from 'classnames';

import { CodeHighlightContext } from '../../context/CodeHighlightContext';
import { useHeaderId } from '../../hooks/useHeaderId';

import * as classes from './style.module.scss';

export interface InteractiveTextProps {
  // add an id for search related linking
  id?: string;
  // added through cloning
  highlightId: string;
  // note: only used in the useInteractiveLanguage hook
  // index starts at 1 instead of 0
  // eslint-disable-next-line react/no-unused-prop-types
  highlight: string | Array<string | number>;
  // note: for useInteractiveLanguage only
  // eslint-disable-next-line react/no-unused-prop-types
  file: number;
  'data-language': string;
  children: React.ReactNode;
}

export const InteractiveText: React.FC<InteractiveTextProps> = ({
  id,
  highlightId,
  'data-language': dataLanguage,
  children,
}) => {
  const { setActiveLines, activeElement } = useContext(CodeHighlightContext);
  const [getSlug] = useHeaderId();
  const [slug] = getSlug([id]);

  const handleSelect = useCallback(() => {
    if (highlightId) {
      setActiveLines(highlightId);
    }
  }, [highlightId]);

  return (
    <div
      id={slug}
      data-id={highlightId}
      data-language={dataLanguage}
      role={highlightId ? 'button' : undefined}
      tabIndex={highlightId ? 0 : undefined}
      onClick={handleSelect}
      onFocus={handleSelect}
      onKeyDown={handleSelect}
      className={classNames(classes.interactive, {
        [classes.highlight]: highlightId,
        [classes.active]: activeElement === highlightId,
      })}
    >
      {children}
    </div>
  );
};
